"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredChatProvider = void 0;
const react_1 = __importStar(require("react"));
const FilteredChatContext_1 = require("./FilteredChatContext");
const FilteredChatProvider = ({ children, openChat, }) => {
    const [reactiveChat, setReactiveChat] = (0, react_1.useState)();
    const [isChatLoading, setIsChatLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const filteredChat = openChat.openFilteredChat();
        setReactiveChat(filteredChat ? { chat: filteredChat } : undefined);
    }, [openChat]);
    (0, react_1.useEffect)(() => {
        let removeChangeListener;
        if (reactiveChat === null || reactiveChat === void 0 ? void 0 : reactiveChat.chat) {
            removeChangeListener = reactiveChat.chat.registerChangeListener((chat) => {
                setReactiveChat(() => ({
                    chat,
                }));
            });
        }
        return () => {
            if (removeChangeListener) {
                removeChangeListener();
            }
        };
    }, [reactiveChat === null || reactiveChat === void 0 ? void 0 : reactiveChat.chat]);
    const setChat = (chat) => {
        setReactiveChat(() => (chat ? { chat: chat } : undefined));
    };
    return (react_1.default.createElement(FilteredChatContext_1.FilteredChatContext.Provider, { value: {
            chat: reactiveChat === null || reactiveChat === void 0 ? void 0 : reactiveChat.chat,
            setChat,
            isChatLoading,
            setIsChatLoading,
        } }, children));
};
exports.FilteredChatProvider = FilteredChatProvider;
